module.exports = __webpack_public_path__ + "static/media/logo.c9623008.jpeg";